<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8 maxw600">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm"
                            placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="searchTerm" autocomplete="off"
                            (keyup.enter)="onQuickSerch()" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" (click)="onQuickSerch()">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="ml-2 advanced-search-box">
                    <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
                        <i class="fa fa-search-plus" aria-hidden="true"></i>
                    </button>
                    <div class="searchbox card fix rt" *ngIf="isAdvanceSearch">

                        <div class="form-row">
                            <div class="col-12">
                                <label translate>lblUser</label>
                                <div class="lbl-info">
                                    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="UserList"
                                        placeholder="{{ 'lblUsers'| translate}}" [(ngModel)]="selectedUser">
                                    </ng-multiselect-dropdown>
                                </div>
                            </div>
                            <div class="col-12">
                                <label translate>lblCreatedDate</label>
                                <div class="date">
                                    <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                                    [(ngModel)]="bookingDate" required />
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col text-right">
                                <button type="submit" (click)="AdvanceSearchSubmit()" class="btn btn-primary mr-sm-2"
                                    translate>
                                    lblApply
                                </button>
                                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-2" translate>
                                    lblReset
                                </button>
                                <button (click)="onClose()" class="btn btn-outline-tertiary mr-sm-2" translate>
                                    lblClose
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12 relative mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
            <button type="submit" (click)="onClickChangeView(false)"
                [ngClass]="isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class="mr-sm-2"
                translate>lblSATodayView
            </button>
            <button (click)="onClickChangeView(true)"
                [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class=""
                translate>lblSAWeekView
            </button>
            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
                (click)='refresh()'>
                <em class="fas fa-sync font15 align-middle"></em>
            </a>
        </div>
        <div
        class="col-xl-4 col-md-7 col-lg-6 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
        <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" style="margin-right: 10px;"
          aria-label="Center Align">
                <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
            </button>
            <!-- PDF -->
            <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" 
                ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
                <em class="far fa-file fa-2x"></em>
                <span class="bdg">PDF</span>
            </button>
        </div>
    </div>
</div>


<!-- Body -->
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <!-- Body Header -->
                <div class="card-header d-flex justify-content-between" translate>
                    lblUserViseAppointment
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
                        {{ totalCount }}
                        &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>

                <!-- Body Content -->
                <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()">
                    <table class="tablest1" id="dealerPdf">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th style="width: 10%" scope="col" translate>lblWoNo</th>
                                <th style="width: 20%" scope="col" sortable="licensePlate" (sort)="onSort($event)"
                                    translate>
                                    lblRegNumber
                                </th>
                                <th scope="col" sortable="customerName" (sort)="onSort($event)" translate>
                                    lblCustomerName
                                </th>
                                <th scope="col" sortable="dealerName" (sort)="onSort($event)" translate>
                                    lblDealersName
                                </th>
                                <th scope="col" sortable="userName" (sort)="onSort($event)" translate>lblUser</th>
                                <th scope="col" sortable="bookedDateTime" (sort)="onSort($event)" translate>
                                    lblAppointmentDate</th>
                                <th scope="col" sortable="createdDateTime" (sort)="onSort($event)" translate>
                                    lblCreatedDate</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="userViseAppointmentList?.length > 0; else load_else">
                                <tr class="click" *ngFor="let appointment of userViseAppointmentList; let i = index">
                                    <td>{{ i+1 }}</td>
                                    <td>
                                        <ngb-highlight [result]="appointment.workorderNumber">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <div class="flmid">
                                            <div class="licplate LPNo d-flex">
                                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                {{ appointment.licensePlate }}
                                            </div>
                                            <div class="imgWid">
                                                <img af-brand-logo [data-code]="appointment.brandCode" data-type="BRAND"
                                                    class="{{ appointment.brandCode }}-icon brandicon"
                                                    alt="{{appointment.brandCode}}" />
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <ngb-highlight [result]="appointment.modelName"
                                                class="flmid semibold fs-12px lh-16px">
                                            </ngb-highlight>
                                        </div>
                                    </td>

                                    <td>
                                        <ngb-highlight [result]="appointment.customerName">
                                        </ngb-highlight>
                                        <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                                            <em _ngcontent-xdg-c220=""
                                                class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                            <span class="fs-12px" *ngIf="appointment && appointment.mobileCode">+{{
                                                appointment.mobileCode }}-</span>
                                            <ngb-highlight class="fs-12px" [result]="appointment.mobileNo">
                                            </ngb-highlight>
                                        </div>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.dealerName">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight style="margin-left: 10px;" [result]="appointment.userName">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight style="margin-left: 10px;"
                                            [result]="appointment.bookedDateTime  | date:'short'">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight style="margin-left: 10px;"
                                            [result]="appointment.createdDateTime  | date:'short'">
                                        </ngb-highlight>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>
                                        lblNoRecordsFound
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>